'use client'
import { StorageService } from '@dynamic-labs/utils';
import { AUTH_EXPIRES_AT } from '../../constants/localStorage.js';

const storeExpiresAt = (expiresAt) => {
    StorageService.setItem(AUTH_EXPIRES_AT, expiresAt);
};

export { storeExpiresAt };
